<style lang="scss" scoped>
.shift-container {
  .hideFormItem {
    display: none !important;
  }

  .form-container {
    margin-top: 15px;
  }

  .tag-container {
    margin-top: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    // 左侧
    .left {
      display: flex;
      align-items: center;
      width: 160px;

      .icon {
        display: inline-block;
        width: 5px;
        height: 16px;
        background: #419fff;
      }

      .txt {
        display: inline-block;
        font-weight: 400;
        font-size: 16px;
        color: #303133;
        margin-left: 12px;
      }
    }

    // 右侧
    .right {
      width: 200px;

      .txt {
        font-size: 24px;
        color: #606266;
      }

      .unit {
        margin-left: 8px;
        font-size: 12px;
        color: #909399;
      }
    }
  }

  .chart-container {
    width: 100%;
    margin-top: 10px;
    min-height: 181px;
    border: 1px solid #e4e7ed;
    display: flex;
    justify-content: space-between;
    align-items: center;

    #shiftChart {
      width: 459px;
      height: 181px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .data {
      flex: 1;
      display: flex;
      //justify-content: space-between;
      align-items: center;
      text-align: center;
      flex-wrap: wrap;

      .item {
        width: 33.3%;
        height: 24px;

        .title {
          font-size: 16px;
        }

        .num {
          margin-left: 8px;
          color: #419fff;
          font-weight: bold;
          font-size: 20px;
        }

        .unit {
          margin-left: 10px;
        }
      }
    }
  }

  .table-container {
    margin-top: 20px;
    width: 100%;
    min-height: 310px;
    margin-bottom: 50px;

    #tableChart {
      width: 100%;
      height: 310px;
    }
  }
}
</style>
<template>
  <div class="shift-container">
    <yi_curd_table v-show="false" v-bind="$attrs" :name="$options.name" ref="yt"> </yi_curd_table>
    <div class="form-container">
      <el-form :style="{ height: screenWidth > 1232 ? '48px' : '' }" :model="conditions" :inline="true" size="mini">
        <el-form-item :label="$t('xuanzeriqi')">
          <yi_time_input type="datetimerange" :maxTime="365 * 24 * 3600 * 1000" :start.sync="conditions.reportDateStart" :end.sync="conditions.reportDateEnd"> </yi_time_input>
        </el-form-item>
        <el-form-item :label="$t('suoshuzuzhi')">
          <yi_data_select :type="'organization'" :ids.sync="conditions.orgIdSelected" :idsPath.sync="conditions.orgId"></yi_data_select>
        </el-form-item>
        <el-form-item :label="$t('shebeimingcheng')">
          <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="conditions.equipmentId"> </yi_data_select>
          <!--          <yi_cross_select multiple :component="'web_base_equipment_list'"-->
          <!--              :ids.sync="conditions.equipmentId">-->
          <!--          </yi_cross_select>-->
        </el-form-item>
        <el-form-item :label="$t('chanpinmingcheng')">
          <yi_data_select :multiple="true" :type="'material2'" :ids.sync="conditions.materialId"> </yi_data_select>
          <!--          <yi_cross_select multiple :component="'web_base_matter_list'" :ids.sync="conditions.materialId">-->
          <!--          </yi_cross_select>-->
        </el-form-item>
        <el-form-item>
          <el-button @click="getSummary(false)" type="primary" plain="plain">
            {{ $t("sousuo") }}
          </el-button>
          <el-button @click="reset">{{ $t("chongzhi") }} </el-button>
          <yi_curd_expand_button></yi_curd_expand_button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tag-container">
      <div class="left">
        <span class="icon"></span>
        <span class="txt">{{ $t("chanliangzonghe") }}</span>
      </div>
      <div class="right">
        <span class="txt">{{ productTotal }}</span>
        <span class="unit">{{ $t("jian") }}</span>
      </div>
    </div>
    <div class="chart-container" :key="key">
      <div id="shiftChart"></div>
      <div class="data">
        <div v-for="(item, index) in pieResult" :key="index" class="item">
          <span class="title">{{ item.name }}{{ $t("chanpinshu") }}</span>
          <span class="num">{{ item.value }}</span>
          <span class="unit">{{ $t("jian") }}</span>
        </div>
      </div>
    </div>
    <div class="tag-container">
      <div class="left">
        <span class="icon"></span>
        <span class="txt">{{ $t("bancimeitianchanliangduibi") }}</span>
      </div>
      <div class="right"></div>
    </div>
    <div class="table-container" :key="key">
      <div v-loading="searchLoading" id="tableChart"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "web_report_equipment_capacity_statistics_production_statistics_shift",
  props: {
    parentParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      searchLoading: false,
      key: 0,
      total: [],
      totalOutput: [],
      totalOutputCharts: null,
      screenWidth: "", // 可视窗口的宽度
      conditions: {},
      pieResult: {},
    };
  },
  watch: {
    parentParams: {
      handler(n) {
        console.log("parentParams666", n);
        if (n.orgId) {
          this.$set(this.conditions, "orgIdSelected", n.orgId);
        }
        if (n.firstDate) {
          this.$set(this.conditions, "reportDateStart", new Date(n.firstDate).getTime());
        }
        if (n.lastDate) {
          this.$set(this.conditions, "reportDateEnd", new Date(n.lastDate).getTime());
        }
        setTimeout(() => {
          this.getSummary(true);
        }, 0);
      },
      immediate: true,
      deep: true,
    },
  },

  mounted() {
    this.resize();
    // console.log('this.$parent.$refs.mychild',this.$parent.$refs.mychild)
    this.utils.event_hub.$on("PRODUCTION_STATISTICS_RESIZE", () => {
      this.resize();
    });
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  activated() {
    this.resize();
  },
  computed: {
    productTotal() {
      let sum = 0;
      if (this.totalOutput.length > 0) {
        for (let i = 0; i < this.totalOutput.length; i++) {
          sum += this.totalOutput[i].value;
        }
      }
      return sum;
    },
  },
  methods: {
    /**
     * 重置
     */
    reset() {
      if (this.parentParams.selectedOrgIds !== undefined) {
        this.$set(this.conditions, "materialId", undefined);
        this.$set(this.conditions, "equipmentId", undefined);
        this.$set(this.conditions, "reportDateStart", new Date(this.parentParams.firstDate).getTime());
        this.$set(this.conditions, "reportDateEnd", new Date(this.parentParams.lastDate).getTime());
        this.$set(this.conditions, "orgId", this.parentParams.selectedOrgIds + "");
        this.$set(this.conditions, "orgIdSelected", this.parentParams.orgId);
        console.log("parentParams", this.parentParams);
        console.log("parentParams111", this.conditions);
        this.getSummary();
      }
      if (this.conditions.orgId !== undefined && this.parentParams.selectedOrgIds == undefined) {
        this.conditions.reportDateStart = undefined;
        this.conditions.reportDateEnd = undefined;
        this.conditions.orgId = undefined;
        this.conditions.orgIdSelected = undefined;
        this.conditions.materialId = undefined;
        this.conditions.equipmentId = undefined;
        this.totalOutput = [];
        this.pieResult = [];
        ++this.key;
        console.log("parentParams999", this.conditions.reportDateStart);
      }
      // console.log('parentParamsddd',this.parentParams.selectedOrgIds)
      // console.log('parentParams999',this.conditions.reportDateStart)
    },
    /**
     * resize
     */
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        this.screenWidth = document.body.clientWidth;
        if (this.totalOutputCharts != null) {
          this.totalOutputCharts.resize();
        }
      }, 500);
    },
    /**
     * getRandomColor
     * @returns {string}
     */
    getRandomColor() {
      let str = "#";
      const arr = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
      for (let i = 0; i < 6; i++) {
        const num = parseInt(Math.random() * 16);
        str += arr[num];
      }
      return str;
    },
    mapSeries(obj) {
      let xAxis = [];
      for (const i in obj) {
        const arr = obj[i];
        const result = arr.reduce((acc, cur) => {
          if (!acc[cur.time]) {
            acc[cur.time] = { time: cur.time, date: cur.date, badQuantitySum: cur.badQuantitySum };
          } else {
            acc[cur.time].badQuantitySum += cur.badQuantitySum;
          }
          return acc;
        }, {});
        obj[i] = Object.values(result);
      }
      if (Object.keys(obj).length > 1) {
        const dates = Array.from(new Set([].concat(...Object.values(obj).map((item) => item.map((subItem) => subItem.time)))));
        // 将不存在的日期添加到班次中，并将 num 值设为 0
        Object.values(obj).forEach((item) => {
          dates.forEach((date) => {
            if (!item.some((subItem) => subItem.time === date)) {
              item.push({ time: date, badQuantitySum: 0 });
            }
          });
        });
        // 对班次中的日期按时间排序
        Object.values(obj).forEach((item) => item.sort((a, b) => a.time.localeCompare(b.time)));
      }
      for (const i in obj) {
        xAxis = obj[i].map((item) => {
          return item.time;
        });
      }
      for (const i in obj) {
        obj[i] = obj[i].map((item) => {
          return item.badQuantitySum;
        });
      }
      const orderedObj = {};
      Object.keys(obj)
        .sort()
        .forEach((key) => {
          orderedObj[key] = obj[key];
        });
      return {
        xAxis: xAxis,
        seriesData: orderedObj,
      };
    },
    /**
     * drawTableChart
     * @param data
     * @param obj
     */
    drawTableChart(data = [], obj = {}) {
      this.resize();
      if (!document.getElementById("tableChart")) {
        return;
      }
      this.totalOutputCharts = this.echarts.getInstanceByDom(document.getElementById("tableChart"));
      if (this.totalOutputCharts == null) {
        this.totalOutputCharts = this.echarts.init(document.getElementById("tableChart"));
      }
      let series = [];
      let xAxis = [];
      let seriesData = {};
      if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          if (!seriesData[data[i]["shiftName"]]) {
            seriesData[data[i]["shiftName"]] = [];
          }
          const date = new Date(data[i]["reportDate"]);
          const month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
          const day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
          data[i]["time"] = month + "-" + day;
          data[i]["date"] = `${month}月${day}日`;
          seriesData[data[i]["shiftName"]].push(data[i]);
        }
      }
      if (Object.keys(seriesData).length > 0) {
        const res = this.mapSeries(seriesData);
        xAxis = res.xAxis;
        seriesData = res.seriesData;
      }
      for (const i in seriesData) {
        console.log("ddddddddddd", seriesData);
        series.push({
          name: i,
          type: "bar",
          barWidth: "12px",
          label: {
            normal: {
              show: false,
              position: "top",
              formatter: "{b}",
              color: "#43A0FF",
            },
          },
          itemStyle: {
            barBorderRadius: 6,
          },
          data: seriesData[i],
          barGap: "80%",
          barCategoryGap: "100%",
        });
      }
      let option = {
        tooltip: {
          trigger: "item",
          formatter: (params) => {
            return params.marker + params.name + "<br/>" + params.seriesName + "：" + params.value + "<br/>";
          },
        },
        grid: {
          left: "20",
          right: "20",
          bottom: "60",
          top: "16%",
          containLabel: true,
        },
        color: ["#419FFF", "#B09BFE", "#AB41FF"],
        legend: {
          left: "center",
          textStyle: {
            color: "#000",
          },
          itemWidth: 15,
          itemHeight: 10,
          itemGap: 25,
        },
        dataZoom: [
          {
            show: true,
            height: 18,
            xAxisIndex: [0],
            bottom: 20,
            start: 0,
            end: 100,
            handleIcon: "path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z",
            handleSize: "100%",
            handleStyle: {
              color: "rgba(255, 255, 255,1)",
            },
            textStyle: {
              color: "#909399",
              fontSize: 12,
            },
            fillerColor: "#CBCED4",
            borderColor: "rgba(255, 255, 255,1)",
            backgroundColor: "#F0F2F5",
            showDataShadow: true,
            brushSelect: false,
          },
          {
            type: "inside",
            disabled: false,
          },
        ],
        xAxis: {
          show: true,
          type: "category",
          nameLocation: "end",
          nameTextStyle: {
            fontSize: 14,
          },
          inverse: false,
          splitLine: {
            show: false,
            lineStyle: {
              type: "dashed",
              color: "#000",
              width: 1,
            },
          },
          axisTick: {
            show: true,
            alignWithLabel: false,
            interval: "auto",
            inside: false,
            length: 5,
            lineStyle: {
              type: "solid",
              width: 1,
              color: "#909399",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: "solid",
              width: 1,
              color: "#909399",
            },
          },
          axisLabel: {
            interval: 0, // 间隔长度，可自定义（如果是时间格式，echarts会自动处理）
            rotate: 0, // 横坐标上label的倾斜度
            showMaxLabel: true, // 显示最大刻度
            showMinLabel: true, // 显示最小刻度
            hideOverlap: true, //隐藏互相遮挡的文本标签
            color: "#909399",
          },
          data: xAxis,
        },
        yAxis: {
          type: "value",
          data: [0, 20, 40, 60, 80, 100],
          axisLabel: {
            show: true,
            interval: "auto",
            formatter: "{value}",
          },
          nameTextStyle: {
            color: "#909399",
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "solid",
              color: "#e4e7ed",
            },
          },
        },
        series: series,
      };
      this.totalOutputCharts.setOption(option);
    },
    /**
     * 渲染图表
     * @param data
     */
    drawLeftChart(data) {
      this.resize();
      let myChart = this.echarts.getInstanceByDom(document.getElementById("shiftChart"));
      if (myChart == null) {
        myChart = this.echarts.init(document.getElementById("shiftChart"));
      }
      let option = {
        color: ["#76B8FE", "#B09BFE", "#EFA1C5", "#EFE7A1", "#EFBDA1", "#E5E5E5", "#e7bcf3", "#8378ea"],
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c}小时 ({d}%)",
        },
        toolbox: {
          show: true,
        },
        legend: {
          itemlength: 8,
          itemWidth: 8,
          orient: "vertical",
          left: "right",
          top: "30%",
          icon: "circle",
          textStyle: {
            color: "#909399",
          },
        },
        series: [
          {
            // name: 'Access From',
            type: "pie",
            radius: "50%",
            data: data,
            label: {
              formatter: "{d}%",
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      if (data.length === 0) {
        myChart.clear();
      } else {
        myChart.setOption(option);
      }
    },
    /**
     * 获取数据
     * @returns {Promise<unknown>}
     */
    getSummary(init) {
      if (init && !this.conditions.reportDateStart) {
        return false;
      }
      this.searchLoading = true;
      let requestParam = {
        ...this.conditions,
        orderBy: "reportDate,shiftName asc",
      };
      if (Array.isArray(requestParam["equipmentId"]) && requestParam["equipmentId"].length > 0) {
        requestParam["equipmentId"] = requestParam["equipmentId"].join(",");
      }
      if (Array.isArray(requestParam["materialId"]) && requestParam["materialId"].length > 0) {
        requestParam["materialId"] = requestParam["materialId"].join(",");
      }
      if (Array.isArray(requestParam["orgId"]) && requestParam["orgId"].length > 0) {
        requestParam["orgId"] = requestParam["orgId"].join(",");
      }
      return this.http
        .get("/web/report/page/manufacturing_statistics_shift?" + this.qs.stringify(requestParam))
        .then((response) => {
          // 饼图
          const pieResult = [];
          const data = response.data.extend;
          for (const i in data) {
            pieResult.push({
              name: i,
              value: data[i]["badQuantitySum"],
              percentage: data[i]["badQuantityRate"],
            });
          }
          this.totalOutput = pieResult;
          this.pieResult = pieResult;
          this.drawLeftChart(pieResult);
          // 表格
          const obj = {};
          if (response.data.rows.length > 0) {
            for (let i = 0; i < response.data.rows.length; i++) {
              if (!obj.hasOwnProperty(response.data.rows[i]["shiftName"])) {
                this.$set(obj, response.data.rows[i]["shiftName"], {});
              }
            }
          }
          this.drawTableChart(response.data.rows, obj);
          this.searchLoading = false;
        })
        .catch((error) => {
          this.$message.error(this.$t(error));
          this.searchLoading = false;
        });
    },
  },
};
</script>
